import React from 'react'

const ChooseUs = () => {
    return (
        <>

            <div className="choose-area py-100" style={{marginTop:"-90px"}}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="choose-content wow fadeInUp" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInUp' }}>
                                <div className="site-heading mb-0">
                                    <span className="site-title-tagline"><i className="fas fa-solar-panel" /> Why Choose Us</span>
                                    <h2 className="site-title">India's <span>Largest Growing</span> Solar Company</h2>
                                    <p>   
                                        Our mission is to provide high-quality, cost-effective, and sustainable energy solutions to reduce carbon footprints—paving the way for sustainable energy and improving the quality of life for both present and future generations.
                                    </p>
                                </div>
                                <div className="choose-content-wrap">
                                    <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="assets/img/icon/money-2.svg" alt />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>Expert Installation and Service</h4>
                                            <p>Our experienced team guarantees you a safe, fast, and professional solar installation.</p>
                                        </div>
                                    </div>
                                    <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="assets/img/icon/staff.svg" alt />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>High-Quality Products</h4>
                                            <p>We use only certified and reliable solar panels and equipment, ensuring superior, long-term performance for you.</p>
                                        </div>
                                    </div>
                                    <div className="choose-item">
                                        <div className="choose-item-icon">
                                            <img src="assets/img/icon/certified.svg" alt />
                                        </div>
                                        <div className="choose-item-info">
                                            <h4>Cost-Effective Solutions</h4>
                                            <p>Greater savings at a lower cost! Our solar systems lead to a significant reduction in your electricity bills.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="choose-img wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <img className="img-1" src="assets/img/choose/01.jpg" alt />
                                <img className="img-2" src="assets/img/choose/02.jpg" alt />
                                <img className="shape" src="assets/img/shape/06.png" alt />
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </>
    )
}

export default ChooseUs